export const IMAGE_PATH =
  "https://imagecdn.shiseido.co.jp/c/a=0,f=webp:jpeg/resources/sw";
